import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row card rounded-0" }
const _hoisted_2 = { class: "col-12 card-header" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12 col-md-6" }
const _hoisted_5 = { class: "col-sm-12 col-md-6" }
const _hoisted_6 = { class: "input-icons" }
const _hoisted_7 = { class: "col-12 card-body" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-10" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = {
  key: 1,
  class: "row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "row card text-white rounded-0 top-header" }, [
      _createElementVNode("div", { class: "col-12 text-center" }, [
        _createElementVNode("h2", { class: "my-3 fw-bold" }, "Quote Requests")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-primary me-5 reset-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetQuotes()))
            }, "Reset Filters")
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("i", {
                class: "fas fa-search",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getQuotes()))
              }),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "search by email",
                class: "float-end",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email_string) = $event)),
                onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.getQuotes()), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.email_string]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.instance_quotes.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instance_quotes.slice(_ctx.page_start,_ctx.page_end), (quote) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: quote.id,
                    class: "col-6 user-mgmt-card mb-2 pt-2",
                    onClick: ($event: any) => (_ctx.router.push({name:'management.quote',params:{request_id:quote.id}}))
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("h4", null, _toDisplayString(quote.user.name), 1),
                        _createElementVNode("p", null, _toDisplayString(quote.user.email), 1),
                        _createElementVNode("small", null, "Date Submitted: " + _toDisplayString(_ctx.moment(quote.created_at).format('MM-DD-YYYY')), 1)
                      ]),
                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-2 d-flex flex-column justify-content-center" }, [
                        _createElementVNode("h3", { class: "text-center" }, [
                          _createElementVNode("i", { class: "fas fa-arrow-circle-right text-primary float-end" })
                        ])
                      ], -1))
                    ]),
                    _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1))
                  ], 8, _hoisted_10))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.instance_quotes.length > 20)
                    ? (_openBlock(), _createBlock(_component_pagination, {
                        key: 0,
                        items: _ctx.instance_quotes,
                        page_start: _ctx.page_start,
                        page_end: _ctx.page_end,
                        onNextPage: _ctx.nextPage,
                        onPreviousPage: _ctx.previousPage,
                        label: 'Quotes'
                      }, null, 8, ["items", "page_start", "page_end", "onNextPage", "onPreviousPage"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[6] || (_cache[6] = [
              _createElementVNode("div", { class: "col-12" }, " No quotes found ", -1)
            ])))
      ])
    ])
  ], 64))
}